import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/AccountsAPI/verifyUnsecuredLoanAPI';

const err = (e, fallback) => e?.ErrorDetails?.ErrorMessage || e?.Message || e?.message || fallback;

export const fetchUnsecuredLoanQueue = createAsyncThunk(
    'verifyUnsecuredLoan/fetchQueue',
    async ({ roleId, type }, { rejectWithValue }) => {
        try { return await api.getVerificationUnsecuredLoans(roleId, type); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch unsecured loan verification queue')); }
    }
);

export const fetchUnsecuredLoanDetail = createAsyncThunk(
    'verifyUnsecuredLoan/fetchDetail',
    async ({ transRefNo, type }, { rejectWithValue }) => {
        try { return await api.getLoanByRefNo(transRefNo, type); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch loan details')); }
    }
);

export const submitApproveLoan = createAsyncThunk(
    'verifyUnsecuredLoan/approve',
    async (payload, { rejectWithValue }) => {
        try { return await api.approveLoan(payload); }
        catch (e) { return rejectWithValue(err(e, 'Error Occurred')); }
    }
);

const initialState = {
    queue: [], queueLoading: false, queueError: null,
    detail: null, detailLoading: false, detailError: null,
    verifyLoading: false,
};

const verifyUnsecuredLoanSlice = createSlice({
    name: 'verifyUnsecuredLoan',
    initialState,
    reducers: {
        clearUnsecuredLoanDetail: (s) => { s.detail = null; s.detailError = null; s.detailLoading = false; },
        resetVerifyUnsecuredLoan: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUnsecuredLoanQueue.pending, (s) => { s.queueLoading = true; s.queueError = null; })
            .addCase(fetchUnsecuredLoanQueue.fulfilled, (s, a) => { s.queueLoading = false; s.queue = a.payload?.Data || []; })
            .addCase(fetchUnsecuredLoanQueue.rejected, (s, a) => { s.queueLoading = false; s.queueError = a.payload; s.queue = []; });

        builder
            .addCase(fetchUnsecuredLoanDetail.pending, (s) => { s.detailLoading = true; s.detailError = null; s.detail = null; })
            .addCase(fetchUnsecuredLoanDetail.fulfilled, (s, a) => { s.detailLoading = false; s.detail = a.payload?.Data || null; })
            .addCase(fetchUnsecuredLoanDetail.rejected, (s, a) => { s.detailLoading = false; s.detailError = a.payload; s.detail = null; });

        builder
            .addCase(submitApproveLoan.pending, (s) => { s.verifyLoading = true; })
            .addCase(submitApproveLoan.fulfilled, (s) => { s.verifyLoading = false; })
            .addCase(submitApproveLoan.rejected, (s) => { s.verifyLoading = false; });
    },
});

export const { clearUnsecuredLoanDetail, resetVerifyUnsecuredLoan } = verifyUnsecuredLoanSlice.actions;

export const selectVULQueue = (s) => s.verifyUnsecuredLoan.queue;
export const selectVULQueueLoading = (s) => s.verifyUnsecuredLoan.queueLoading;
export const selectVULQueueError = (s) => s.verifyUnsecuredLoan.queueError;
export const selectVULDetail = (s) => s.verifyUnsecuredLoan.detail;
export const selectVULDetailLoading = (s) => s.verifyUnsecuredLoan.detailLoading;
export const selectVULDetailError = (s) => s.verifyUnsecuredLoan.detailError;
export const selectVULVerifyLoading = (s) => s.verifyUnsecuredLoan.verifyLoading;

export default verifyUnsecuredLoanSlice.reducer;
